import { Tokens } from 'src/app/core/user/user.selectors';
import { PostVerifyAction } from 'src/app/pages/recover/recover.actions';
import { RecoverState } from 'src/app/pages/recover/recover.state';
import {
	QUERY_PARAM_CARD_INDEX,
	QUERY_PARAM_ETOKEN,
	QUERY_PARAM_MFA_TOKEN,
	QUERY_PARAM_OTOKEN,
	QUERY_PARAM_REDIRECT_TO,
} from 'src/app/shared/enums/query-param.enums';
import { Dictionary } from 'src/app/shared/types/dictionary';
import { validString } from 'src/app/shared/utilities/types.utils';

/**
 * Returns the params to use with our accesso pay redirect.
 * @param params The query params
 * @returns The params to send to the redirect
 */
export function getAccessoPayRedirectParams(params: RecoverState): Dictionary<string> {
	return Object.keys(params).reduce((acc, key) => {
		if (
			![QUERY_PARAM_ETOKEN, QUERY_PARAM_OTOKEN, QUERY_PARAM_REDIRECT_TO].includes(key) &&
			validString(params[key])
		) {
			acc[key] = params[key];
		}
		return acc;
	}, {});
}

/**
 * Returns the payment redirect URL
 * @returns The payment redirect URL for accesso Pay
 */
export function getPaymentRedirectUrl(tokens: Tokens, cardIndex: number, window: Window, mfaCode?: string): string {
	const { protocol, pathname, host } = window.location;
	const path = pathname.split('?')[0].split('/').slice(1, 4).join('/');
	let mfaParam = '';

	if (validString(mfaCode)) {
		mfaParam = `&${QUERY_PARAM_MFA_TOKEN}=${mfaCode}`;
	}

	return `${protocol}//${host}/${path}/auto-login?${QUERY_PARAM_OTOKEN}=${tokens.oToken}&${QUERY_PARAM_ETOKEN}=${tokens.eToken}&${QUERY_PARAM_REDIRECT_TO}=${PostVerifyAction.ThreeDS}&${QUERY_PARAM_CARD_INDEX}=${cardIndex}${mfaParam}`;
}
